import type { MutableRefObject } from 'react';

import { useEffect } from 'react';

export function useOnResize(elementRef?: MutableRefObject<HTMLElement | null>, callback?: ResizeObserverCallback) {
  useEffect(() => {
    const element = elementRef?.current;

    if (!element || !callback || !window.ResizeObserver) return;

    const observer = new ResizeObserver(callback);
    observer.observe(element);

    return () => observer.disconnect();
  }, [elementRef, callback]);
}
